<template>
  <vs-button
    ref="loadableButton"
    v-bind="$attrs"
    :class="effectiveClass"
    :color="color"
    :disabled="disabled || isLoading"
    v-on="listeners">
    <slot />
  </vs-button>
</template>

<script>
export default {
  name: "LoaderButton",

  inheritAttrs: false,

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    btnClass: {
      type: String,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    isLoading: false,
  }),

  computed: {
    effectiveClass() {
      const width = this.btnClass ?? (this.compact ? "" : "sm:w-auto w-full")
      return `vs-con-loading__container${width ? ` ${width}` : ""}`
    },
    listeners() {
      return {
        ...this.$listeners,
        click: this.handleClick,
      }
    },
  },

  beforeDestroy() {
    if (this.isLoading) {
      this.$vs.loading.close(this.$refs.loadableButton?.$el)
    }
  },

  methods: {
    async handleClick(e) {
      if (typeof this.$listeners.click !== "function") return

      try {
        this.isLoading = true
        this.$vs.loading({
          color: this.color,
          container: this.$refs.loadableButton.$el,
          scale: 0.45,
        })

        await this.$listeners.click(e)
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        this.isLoading = false
        this.$vs.loading.close(this.$refs.loadableButton?.$el)
      }
    },
  },
}
</script>
<style></style>
